import { useSelector } from "react-redux";
import signupImg from "../assets/Images/signup.webp"
import Template from "../conponents/core/Auth/Template"

function Signup() {
  const {loading} = useSelector((state) => state.auth);

  return (
    <>
      {
        loading ? (
          <div className="flex justify-center items-center my-auto">
            <div className="spinner">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
        ) : (
          <Template
            title="Join the millions learning to code with StudyNotion for free"
            description1="Build skills for today, tomorrow, and beyond."
            description2="Education to future-proof your career."
            image={signupImg}
            formType="signup"
          />
        )
      }
    </>
  )
}

export default Signup
